import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar'
import { Link } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'

export default function Landing() {
    const [companyname, setCompanyname] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    const [memberName, setMemberName] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        setCompanyLogo(localStorage.getItem('companylogo'))
        setCompanyname(localStorage.getItem('mem_company_name'))
        setMemberName(localStorage.getItem('membername'))
    }, [])

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='fullwidth p-50 text_center pull_left '>
                    <div className='logoholder'><img src={companyLogo} /></div>
                    <h2 className='welcomeheading'>Welcome back {memberName}</h2>

                </div>
                <div className='contentarea fullwidth pull_left'>
                    <p className='text_center shorttag'>Welcome back {memberName}. You can now start your journey by selecting an option from your left side panel. Control your and your team work smoothly with minimum effort.<br></br><br></br>Let's start our today's work, good luck</p>
                </div>
            </div>
        </div>
    )
}
